import { inject, observer } from 'mobx-react';
import React, { ChangeEvent, Component } from 'react';
import styled from 'styled-components';
import { Button, Toast, ToastType, withStateCard } from '../../Components';
import { FormPreProjetoCard } from './Components/FormPreProjetoCard';
import { RouteComponentProps } from 'react-router';
import Tutorial_Aluno from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Aluno.pdf";
import {
  PROFESSOR_STORE,
  ProfessorStore,
  PREPROJETO_STORE,
  PreProjetoStore,
  PreProjetoModelValidator,
  ProfessorModel,
  SituacaoDoPreProjeto,
} from '../../Store';
import { apiState } from '../../Api';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import PageSubTitle from '../../Components/PageSubTitle';

interface IProps extends RouteComponentProps {
  [PROFESSOR_STORE]: ProfessorStore
  [PREPROJETO_STORE]: PreProjetoStore
}

interface IState {
  aceitouTermosParaEnvio: boolean,
  aceitouTermosParaAlterar: boolean,
  naoEscolheuOsOrientadores: boolean,
  orientadoresIguais: boolean
  dentroDoPeriodoDeIncricao: boolean
  apiState: number
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const ContainerWithState = withStateCard(Container);

const StyledTutorialButton = styled(Button)`
  margin-left: auto;
`

const StyledText = styled.span`
  padding: 5px;
`

@inject(PROFESSOR_STORE, PREPROJETO_STORE)
@observer
export default class PreProjetoPage extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      aceitouTermosParaEnvio: false,
      aceitouTermosParaAlterar: false,
      naoEscolheuOsOrientadores: false,
      orientadoresIguais: false,
      dentroDoPeriodoDeIncricao: true,
      apiState: apiState.loading,
    }
  }

  getProfessores = async () => {
    const professorStore = this.props[PROFESSOR_STORE]
    await professorStore.getProfessores()
  }

  getPreProjeto = async () => {
    const preProjetoStore = this.props[PREPROJETO_STORE]
    await preProjetoStore.buscarPreProjetoDoAlunoAtual()
  }

  handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    const store = this.props[PREPROJETO_STORE]
    const { name, value } = event.target
    store.updateAttribute(name, value)
  }

  handleOrientadoresSelectChange = (e: ChangeEvent<HTMLSelectElement>, index: number) => {

    const id = Number(e.target.value)
    const professorStore = this.props[PROFESSOR_STORE];
    const { professores } = professorStore;
    const store = this.props[PREPROJETO_STORE]

    if (id == 0) {
      store.updateArray('orientadores', index, new ProfessorModel())
    } else {
      store.updateArray(
        'orientadores',
        index,
        professores.find(o => o.id == id)
      )
    }
  }

  handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    field === 'aceitouTermosParaEnvio'
      ? this.setState({ aceitouTermosParaEnvio: e.target.checked })
      : this.setState({ aceitouTermosParaAlterar: e.target.checked })
  }

  onResumeClick = () => {
    window.open(Tutorial_Aluno);
  }

  verificarSeTresOrientadoresForamEscolhidos = () => {
    const store = this.props[PREPROJETO_STORE]
    const { orientadores } = store
    const list = []
    orientadores.forEach(o => {
      if (o.id == 0) list.push(o)
    })
    if (list.length > 0) return false
    return true
  }

  verificarSeTodosOrientadoresDiferentes(array: number[]) {
    var filtrado = array.filter(function (elem, pos, arr) {
      return arr.indexOf(elem) == pos;
    });

    return filtrado.length === array.length;
  }

  verificarSePeriodoDeInscricao = async () => {
    const preProjetoStore = this.props[PREPROJETO_STORE]
    await preProjetoStore.getParamsPreProjeto()
    const { parametros } = preProjetoStore

    const hoje = new Date()
    const inicio = new Date(parametros && parametros.dataDeInicioInscricoes)
    const fim = new Date(parametros && parametros.dataDeFimInscricoes)

    if (hoje >= inicio && hoje <= fim) {
      this.setState({ dentroDoPeriodoDeIncricao: true })
    } else {
      this.setState({ dentroDoPeriodoDeIncricao: false })
    }
  }

  enviarFormulario = async () => {
    const store = this.props[PREPROJETO_STORE]
    const {
      tema,
      titulo,
      justificativa,
      desenvolvimento,
      bibliografia,
      orientadores,
      setValidationError,
    } = store

    const errors = PreProjetoModelValidator.getErrors({
      tema: tema,
      titulo: titulo,
      justificativa: justificativa,
      desenvolvimento: desenvolvimento,
      bibliografia: bibliografia,
    })

    if (errors) {
      setValidationError(errors)
      if (!this.verificarSeTresOrientadoresForamEscolhidos()) {
        this.setState({ naoEscolheuOsOrientadores: true })
        return
      }
      return
    }

    if (!this.verificarSeTodosOrientadoresDiferentes(orientadores.map(o => o.id))) {
      this.setState({ orientadoresIguais: true })
      return
    }

    if (!this.verificarSeTresOrientadoresForamEscolhidos()) {
      this.setState({ naoEscolheuOsOrientadores: true })
      return
    }

    this.setState({ naoEscolheuOsOrientadores: false })
    setValidationError({})
    await store.enviarFormulario()
    this.getPreProjeto()
  }

  editarFormulario = async () => {
    const store = this.props[PREPROJETO_STORE]
    const {
      tema,
      titulo,
      justificativa,
      desenvolvimento,
      bibliografia,
      orientadores,
      setValidationError,
    } = store

    const errors = PreProjetoModelValidator.getErrors({
      tema: tema,
      titulo: titulo,
      justificativa: justificativa,
      desenvolvimento: desenvolvimento,
      bibliografia: bibliografia,
    })

    if (errors) {
      setValidationError(errors)
      if (!this.verificarSeTresOrientadoresForamEscolhidos()) {
        this.setState({ naoEscolheuOsOrientadores: true })
        return
      }
      return
    }

    if (!this.verificarSeTodosOrientadoresDiferentes(orientadores.map(o => o.id))) {
      this.setState({ orientadoresIguais: true })
      return
    }

    if (!this.verificarSeTresOrientadoresForamEscolhidos()) {
      this.setState({ naoEscolheuOsOrientadores: true })
      return
    }

    this.setState({ naoEscolheuOsOrientadores: false })
    this.setState({ orientadoresIguais: false })
    setValidationError({})
    await store.editarFormulario()
    this.setState({ aceitouTermosParaAlterar: false })
    this.getPreProjeto()
  }

  async componentDidMount() {
    await this.getProfessores()
    await this.getPreProjeto()
    await this.verificarSePeriodoDeInscricao()
  }

  render() {
    const professorStore = this.props[PROFESSOR_STORE]
    const store = this.props[PREPROJETO_STORE]
    const { professores } = professorStore
    const {
      preProjetoValidationError,
      orientadores,
      preProjeto,
      tema,
      titulo,
      justificativa,
      desenvolvimento,
      bibliografia,
      preProjetoState
    } = store

    return (
      <>
        <PageSubTitle subTitle={`${!preProjeto ? 'Cadastro' : 'Resumo'} do Pré-Projeto`} />
        <StyledTutorialButton
          type="button"
          color="primaryLightColor"
          onClick={this.onResumeClick}
        >
          Tutorial de Uso
        </StyledTutorialButton>
      <ContainerWithState
        state={preProjetoState}
      >
        <GlobalErrorToast messages={preProjetoValidationError && preProjetoValidationError.global} />
        {preProjeto && preProjeto.situacao != SituacaoDoPreProjeto.recusado &&
          <Toast type={ToastType.warning}>
            <StyledText>
              Seu Pré-Projeto foi enviado para análise dos orientadores. Aguarde o resultado!
          </StyledText>
          </Toast>
        }
        {preProjeto && preProjeto.situacao == SituacaoDoPreProjeto.recusado &&
          <Toast type={ToastType.error}>
            <StyledText>
              Seu Pré-Projeto foi recusado pelos orientadores escolhidos. Aguarde designação do Nuprajur.
            </StyledText>
          </Toast>
        }
        {!this.state.dentroDoPeriodoDeIncricao &&
          <Toast type={ToastType.error}>
            <StyledText>
              Período de inscrição encerrado!
            </StyledText>
          </Toast>
        }
        <FormPreProjetoCard
          onTextChange={this.handleTextChange}
          onSelectChange={this.handleOrientadoresSelectChange}
          onCheckboxChange={this.handleCheckboxChange}
          aceitouTermosParaEnvio={this.state.aceitouTermosParaEnvio}
          aceitouTermosParaAlterar={this.state.aceitouTermosParaAlterar}
          naoEscolheuOsOrientadores={this.state.naoEscolheuOsOrientadores}
          orientadoresIguais={this.state.orientadoresIguais}
          professores={professores}
          tema={tema}
          titulo={titulo}
          justificativa={justificativa}
          desenvolvimento={desenvolvimento}
          bibliografia={bibliografia}
          orientadores={orientadores}
          errors={preProjetoValidationError}
          preProjeto={preProjeto}
          disabled={!this.state.dentroDoPeriodoDeIncricao || preProjeto && preProjeto.situacao === SituacaoDoPreProjeto.aprovado}
        />
        {!preProjeto
          ?
          <Button onClick={() => this.enviarFormulario()}
            disabled={!this.state.aceitouTermosParaEnvio}>
            Enviar Formulário
          </Button>
          :
          <Button onClick={() => this.editarFormulario()}
            disabled={!this.state.aceitouTermosParaAlterar}>
            Salvar Alterações
          </Button>
        }
      </ContainerWithState>
      </>
    );
  }
}